import { ISalesOrder } from '../../order/interfaces/order.interface';
import { EPicklistOderStatus } from '../../picklist/interfaces/picklist.interface';

export interface ISalesOrderState {
  submitting :boolean;
  currentSalesOrder :ISalesOrder;
}

export interface ISalesOrderStatus {
  custom_field_values :any;
  orderStatus :EPicklistOderStatus;
  orderStatusCount :number;
  order_items :[];
  order_items_count :number;
}

export interface ISalesOrderGroup {
  identifier :any;
  count :number;
  group :string;
  field :string;
  label :string;
}

export enum ESalesOrderStatusHuman {
  SHIPPED = 'Shipped',
  ON_HOLD = 'On Hold',
  CANCELLED = 'Cancelled',
  AWAITING_SHIPMENT = 'Awaiting Shipment',
  PARTIALLY_SHIPPED = 'Partially Shipped',
  PENDING = 'Pending',
}
export enum ESalesOrderStatusValue {
  ALL = 'pending,on_hold,awaiting_shipment,partially_shipped,shipped,cancelled,refunded,partially_refunded',
  CANCELLED = 'cancelled',
  AWAITING_SHIPMENT = 'awaiting_shipment',
  ON_HOLD = 'on_hold',
  PARTIALLY_SHIPPED = 'partially_shipped',
  PENDING = 'pending',
  SHIPPED = 'shipped',
}

export enum ESalesOrderPickingStatus {
  PICKLIST_CREATED = 'PICKLIST_CREATED',
  NOT_IN_PICKING = 'NOT_IN_PICKING',
  PICKLIST_PICKING = 'PICKLIST_PICKING',
  NO_ENOUGH_STOCKS = 'NO_ENOUGH_STOCKS',
  PICKLIST_PACKED = 'PICKLIST_PACKED',
  PICKLIST_PICKED = 'PICKLIST_PICKED',
}

export const CSalesOrderStatusConstant :TSalesOrderStatus = {
  SHIPPED: 'shipped',
  AWAITING_SHIPMENT: 'awaiting_shipment',
  PENDING: 'pending',
  CANCELLED: 'cancelled',
  PARTIALLY_SHIPPED: 'partially_shipped',
  ON_HOLD: 'on_hold',
};

export type TSalesOrderStatus = {
  SHIPPED :string;
  AWAITING_SHIPMENT :string;
  PENDING :string;
  CANCELLED :string;
  PARTIALLY_SHIPPED :string;
  ON_HOLD :string;
};

export type TUpdateStatusPayload = {
  salesOrders :ISalesOrder[];
  orderStatus :string;
  trackingNumber ?:string;
  carrierCode ?:string;
  salesOrderParams ?:any;
  isSelectedAllRows ?:boolean;
};

export enum EQuickFulfillmentActions {
  CREATE_PICKLIST = 'create_picklist',
  EXPORT_PACKING_SLIP = 'export_packing_slip',
  EXPORT_SALES_ORDER = 'export_sales_order',
  BULK_UPDATE_TAGS = 'bulk_update_tags',
  BULK_UPDATE_ORDER_STATUS = 'bulk_update_order_status',
}

export interface ISalesOrderSource {
  id :string;
  name :string;
}

export enum ESalesOrderSourceValue {
  LUMINOUS = 'luminous',
  SHIPSTATION = 'shipstation',
  AMAZON = 'amazon',
  TRANSFER_ORDER = 'transfer_order',
}

export enum ESalesOrderSelectAllAction {
  UPDATE_ORDER_STATUS = 'updateOrderStatus',
  GET_ORDER_UPDATES = 'getOrderUpdates',
  UPDATE_TAGS = 'updateTags',
  SHIP_ORDERS = 'shipOrders',
  CREATE_PICKLIST_PER_ORDER = 'createPicklistPerOrder',
}

export interface ISalesOrderActionsPayload {
  salesOrderShipmentId ?:number; // THIS IS FULFILLMENT ORDER ID (ID FROM sales_orders_shipments)
  shipstationShipmentId ?:number; // THIS IS THE ACTUAL SHIPMENT ID (ID FROM shipstation_shipments)
}

export interface ISalesOrderRollbackItem {
  id :number;
  orderItemId :number;
  orderId :number;
  orderNumber :string;
  rfqId :number;
  internalSku :string;
  productName :string;
  locationId :number;
  locationName :string;
  warehouseGroupId :number;
  warehouseGroupName :string;
  quantity :string;
  orderStatus :string;
  isOrderShipped :boolean;
}

export enum ESalesOrderAllocatedStatus {
  ALLOCATED = '1',
  UNALLOCATED = '0',
}

export enum ESalesOrderLineItemStatus {
  ACCEPTED = 'accepted',
  BACKORDERED = 'backordered',
  REJECTED = 'rejected',
  QUANTITY_CHANGED = 'quantity_changed',
}

export const CSalesOrderStatusLabel :Record<string, string> = {
  [CSalesOrderStatusConstant.SHIPPED]: 'Shipped',
  [CSalesOrderStatusConstant.AWAITING_SHIPMENT]: 'Awaiting Shipment',
  [CSalesOrderStatusConstant.PENDING]: 'Pending',
  [CSalesOrderStatusConstant.CANCELLED]: 'Cancelled',
  [CSalesOrderStatusConstant.PARTIALLY_SHIPPED]: 'Partially Shipped',
  [CSalesOrderStatusConstant.ON_HOLD]: 'On Hold',
};
